import React, { Component } from 'react';
import { observer, inject} from 'mobx-react';
import ChangePasswordForm from './changePasswordForm';
import IconComponent from '../../portal/iconComponent';

@inject('translationsStore', 'authStore','changePasswordStore') @observer
export default class ChangePasswordContainer extends Component {

    state = {
        oldPasswordText: null,
        headerText: null
    };
    componentWillMount() {

        if (this.props.changePasswordStore.isPasswordExpired) {
            this.setState({
                oldPasswordText: this.props.translationsStore.translate('CURRENT_PASSWORD'),
                headerText: this.props.translationsStore.translate('MY_PROFILE_CHANGE_PASSWORD')
            });
        }
        else {
            this.setState({
                oldPasswordText: this.props.translationsStore.translate('TEMPORARY_PASSWORD'),
                headerText: this.props.translationsStore.translate('CHANGE_PASSWORD_HEADER')
            });
        }
        this.props.authStore.setRequireChangePasswordForResetFlow(false);
    }

    render(){        

        return(
            <div className='change-password-main-wrapper' data-cy='change-password-screen'>
                <div className='logo-wrapper'>
                    <IconComponent iconClassName='cx-logo-and-text-icon' />
                </div>
                <div>
                    <ChangePasswordForm
                        header={this.state.headerText}
                        oldPasswordText={this.state.oldPasswordText}
                        redirectAfterChange={true}
                    />
                </div>                               
            </div>
        );
    }
}
